import {declination} from '@/utils/declination.js'

export const subscriptionStatuses = {
  new: 'new',
  pending: 'pending',
  active: 'active',
  disabled: 'disabled',
}

export const paymentStatuses = {
  pending: 'pending',
  success: 'success',
  failed: 'failed',
}

export const subscriptionFeatures = {
  'Younesis Free': {
    // Твой тариф сейчас
    selection: [
      {
        type: 'check',
        text: 'Нетворкинг',
      },
      {
        type: 'check',
        text: 'Календарь мероприятий',
      },
      {
        type: 'check',
        text: 'Ярмарка бесплатных продуктов',
      },
    ],
  },
  'Практикум по таблицам': {
    order: 0
  },
  'Younesis Base 1 месяц': {
    order: 1,
    selection: [
      {
        type: 'check',
        text: 'Всё что входит в тариф «Free»',
      },
      {
        type: 'check',
        text: 'Доступ к размещению бесплатных продуктов на ярмарке',
      },
    ],
    full: [
      {
        type: 'check',
        text: 'Нетворкинг',
      },
      {
        type: 'check',
        text: 'Календарь мероприятий',
      },
      {
        type: 'check',
        text: 'Доступ к размещению бесплатных продуктов на ярмарке',
      },
      {
        type: 'check',
        text: 'Доступ к размещению своих мероприятий в календаре',
      },
      {
        type: 'gray',
        text: 'Мероприятия должны пройти модерацию',
      },
      {
        type: 'check',
        text: 'Помощь в оформлении визитки',
      },
      {
        type: 'check',
        text: 'Помощь в оформлении бесплатных продуктов на ярмарке',
      },
      {
        type: 'check',
        text: 'Ярмарка бесплатных продуктов',
      },
    ],
  },
  'Younesis Base + 3 месяца': {
    order: 2,
    selection: [
      {
        type: 'check',
        text: 'Всё что входит в тариф «Base» со скидкой 20%',
      },
    ],
    full: [
      {
        type: 'check',
        text: 'Нетворкинг',
      },
      {
        type: 'check',
        text: 'Календарь мероприятий',
      },
      {
        type: 'check',
        text: 'Доступ к размещению бесплатных продуктов на ярмарке',
      },
      {
        type: 'check',
        text: 'Доступ к размещению своих мероприятий в календаре',
      },
      {
        type: 'gray',
        text: 'Мероприятия должны пройти модерацию',
      },
      {
        type: 'check',
        text: 'Помощь в оформлении визитки',
      },
      {
        type: 'check',
        text: 'Помощь в оформлении бесплатных продуктов на ярмарке',
      },
      {
        type: 'check',
        text: 'Ярмарка бесплатных продуктов',
      },
    ]
  },
  'Younesis Premium 12 месяцев': {
    order: 3,
    anotherName: 'Таня рекомендует!',
    selection: [
      {
        type: 'check',
        text: 'Всё что входит в тариф «Base»',
      },
      {
        type: 'plus',
        text: 'Доступ к легендарной <span style="color: #CF2E2E; font-weight: 700;">«Школе продюсера»</span> Татьяны Маричевой и всем предстоящим обновлениям',
      },
    ],
    full: [
      {
        type: 'check',
        text:`<span
              style="font-size: 18px; font-weight: 500; margin-bottom: 8px;"
            >
              Премиум функции
            </span>
            <span
              style="font-size: 14px; font-weight: 400;"
            >
              Выделяющиеся статусы, приоритет в выдаче, увеличенное количество символов в визитке и другие решения. Пока другие «в процессе поиска», ты уже в процессе запуска 🚀
            </span>`,
      },
      {
        type: 'check',
        text:`<span
              style="font-size: 18px; font-weight: 500; margin-bottom: 8px;"
            >
              Доступ ко всем мастер-классам
            </span>
            <span
              style="font-size: 14px; font-weight: 400;"
            >
              Конкретные инструкции от ТОПов рынка, которые системно делают десятки миллионов, а не только консультируют по тому как правильно консультировать 📚
            </span>`,
      },
      {
        type: 'check',
        text:`<span
              style="font-size: 18px; font-weight: 500; margin-bottom: 8px;"
            >
              Закрытый чат в Telegram
            </span>
            <span
              style="font-size: 14px; font-weight: 400;"
            >
              Эфиры и подкасты от авторов курсов, практиков и топов рынка по твоим запросам в чате. А также возможность влиять на то, какие функции появятся на платформе 😎
            </span>`,
      },
      // {
      //   type: 'check',
      //   text: 'Нетворкинг',
      // },
      // {
      //   type: 'check',
      //   text: 'Календарь мероприятий',
      // },
      // {
      //   type: 'check',
      //   text: 'Доступ к размещению бесплатных продуктов на ярмарке',
      // },
      // {
      //   type: 'check',
      //   text: 'Доступ к размещению своих мероприятий в календаре',
      // },
      // {
      //   type: 'gray',
      //   text: 'Мероприятия должны пройти модерацию',
      // },
      // {
      //   type: 'check',
      //   text: 'Помощь в оформлении визитки',
      // },
      // {
      //   type: 'check',
      //   text: 'Помощь в оформлении бесплатных продуктов на ярмарке',
      // },
      // {
      //   type: 'check',
      //   text: 'Ярмарка бесплатных продуктов',
      // },
      // {
      //   type: 'check',
      //   text: 'Доступ к легендарной <span style="color: #CF2E2E; font-weight: 700;">«Школе продюсера»</span> Татьяны Маричевой и всем предстоящим обновлениям',
      // },
    ]
  },
}

export function singleSubscriptionPeriodLabel(type) {
  switch (type) {
  case 'day': return 'день'
  case 'month': return 'мес'
  default: return type
  }
}

export function finalSubscriptionPeriodLabel(type, count) {
  switch (type) {
  case 'day': return `${count} ${declination('дней', 'день', 'дня', count)}`
  case 'month': {
    if(count === 12) {
      return declination('год', 'год', 'года', count)
    }
    return `${count} ${declination('месяцев', 'месяц', 'месяца', count)}`
  }
  default: return type
  }
}

export function subscriptionPeriodAdjective(priceOrPeriod, periodCount) {
  const period = typeof priceOrPeriod === 'object' && priceOrPeriod !== null
    ? priceOrPeriod.period
    : priceOrPeriod
  const count = typeof priceOrPeriod === 'object' && priceOrPeriod !== null
    ? priceOrPeriod.period_count
    : periodCount

  if (period === 'month') {
    switch (count) {
    case 1: return 'Месячная'
    case 3: return 'Квартальная'
    case 6: return 'Полугодовая'
    case 12: return 'Годовая'
    default:
      return `${count} ${declination('месяцев', 'месяц', 'месяца', count)}`
    }
  }

  if (period === 'day') {
    switch (count) {
    case 1: return 'Дневная'
    default:
      return `${count} ${declination('дней', 'день', 'дня', count)}`
    }
  }

  return `${count} ${period}`
}

export function subscriptionPeriodDurationLabel(priceOrPeriod, periodCount) {
  const period = typeof priceOrPeriod === 'object' && priceOrPeriod !== null
    ? priceOrPeriod.period
    : priceOrPeriod
  const count = typeof priceOrPeriod === 'object' && priceOrPeriod !== null
    ? priceOrPeriod.period_count
    : periodCount

  if (period === 'month') {
    switch (count) {
    case 1:
      return `1 ${declination('месяцев', 'месяц', 'месяца', 1)}`
    case 6:
      return 'полгода'
    case 12:
      return `1 ${declination('лет', 'год', 'года', 1)}`
    default:
      return `${count} ${declination('месяцев', 'месяц', 'месяца', count)}`
    }
  }

  if (period === 'day') {
    return `${count} ${declination('дней', 'день', 'дня', count)}`
  }

  return `${count} ${period}`
}

const DAYS_PER_PERIOD = {
  day: 1,
  month: 30,
  year: 360,
}

export function periodInDays(priceOrPeriod, periodCount) {
  const period = typeof priceOrPeriod === 'object' && priceOrPeriod !== null
    ? priceOrPeriod.period
    : priceOrPeriod
  const count = Number(
    typeof priceOrPeriod === 'object' && priceOrPeriod !== null
      ? priceOrPeriod.period_count
      : periodCount
  ) || 0

  const daysPerUnit = DAYS_PER_PERIOD[period]
  if (!daysPerUnit) {
    return 0
  }

  return count * daysPerUnit
}
